import { useEffect } from 'react';

// Full-viewport modal that plays back a recorded clip via Cloudflare Stream's
// /iframe embed. Used from Between to let the customer re-watch what they
// just recorded, and from ThankYou so they can rewatch what they submitted.
//
// Stream's /iframe player handles HLS/MP4 selection, adaptive bitrate,
// captions, and mobile fullscreen for us — no <video> tag gymnastics on our
// side. We just drop the iframe in a 16:9 frame and stay out of the way.
//
// Dismisses on backdrop click, X-button click, and Esc.
// Locks body scroll while open so the page underneath doesn't drift on
// touch devices.
export default function ClipPlayerOverlay({ clip, script, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="vt-player-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Video playback"
    >
      <div
        className="vt-player-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="vt-player-head">
          <span className="vt-player-title">
            {script?.title || 'Your video'}
          </span>
          <button
            type="button"
            className="vt-player-close"
            onClick={onClose}
            aria-label="Close video"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="6" y1="6" x2="18" y2="18"/>
              <line x1="6" y1="18" x2="18" y2="6"/>
            </svg>
          </button>
        </div>
        <div className="vt-player-frame">
          <iframe
            src={clip.iframe_url}
            title={script?.title || 'Your video'}
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowFullScreen
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
}
